import Global from '/js/core/global.js';
import NonTcStrings from '/js/util/non-tc-strings.js';
import Analytics from './analytics';

/**
 * Static class with localized strings.
 * They get loaded from xml files which originally come from the Android app.
 * (Plus some entries that come from `NonTcStrings`).
 */
export default class Strings {

  static #map = {};

  /**
   * Loads the UI strings data and calls back.
   *
   * @param languageCode
   * @param callback Includes param value `true` for success
   */
  static load(languageCode, callback) {
    const onSuccess = function(data, textStatus, jqXHR) {
      cl('strings file loaded for ' + languageCode);
      // Parse xml and make map.
      const $xml = $(data);
      const $nodes = $xml.find("string");
      this.#map = {};
      for (const node of $nodes) {
        const $node = $(node);
        const key = $node.attr("name");
        const value = $node.text();
        this.#map[key] = value;
      }
      // Also add entries from `NonTcStrings`:
      for (const key in NonTcStrings.map) {
        const object = NonTcStrings.map[key];
        const value = object[Global.languageCode];
        this.#map[key] = value;
      }
      callback(true);
    };
    const onError = function(jqXHR, textStatus, errorThrown) {
      Analytics.trackStartupError("stringsFile", jqXHR.status);
      callback(false);
    };

    const path = `strings/strings_${languageCode}.xml`;
    $.ajax({
        url: path,
        dataType: "xml",
        success: onSuccess,
        error: onError,
        context: this });
  }

  static get(stringId) {
    const string = this.#map[stringId];
    if (!string) {
      clw("WARNING: No string for " + stringId);
      return "";
    }
    return string;
  }

  /**
   * Convenience function.
   */
  static populateElement($el, stringId) {
    const string = this.get(stringId);
    $el.text(string);
  }

  // TODO: `%1$s` action. May need to consider zero/singular/plural action and add params or methods.
  // TODO: May not need this functionality at all for widget yet.
  static getAndReplaceValue(stringId, myInt) {
    return null;
  }
}
